export enum WebButtonPosition {
  LEFT = 'left',
  RIGHT = 'right',
}
